import axios from "axios";
import { notify } from "./util/helpers";

const urlLookup = {
  adult: {
    development: "https://devapi.rosehealth.com",
    staging: "https://stagingapi.rosehealth.com",
    production: "https://api.rosehealth.com",
  },
  youth: {
    development: "https://youthdevapi.rosehealth.com",
    staging: "https://youthstagingapi.rosehealth.com",
    production: "https://youthapi.rosehealth.com",
    preprod:"https://youthpreprodapi.rosehealth.com/"
  },
};

export const BASE_URL =
  urlLookup[process.env.REACT_APP_DASHBOARD_TYPE][process.env.REACT_APP_ENV];

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    //* Additional Interceptor Logic for request goes here
    if (Object.values(config.params || {}).some((param) => param === undefined || param === null || Number.isNaN(param) || param === "NaN")) {
      // Log or handle the error as needed
      console.error('Undefined parameter found in the request. Request aborted.');
    }
    else
      return config;
  },
  (error) => {
    console.log("error: " + error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    //* Additional Interceptor Logic for response goes here
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        // Handle 401 error, e.g. logout user
        // store.dispatch(logout());
        if (
          error.response?.data?.detail !==
          "Given token not valid for any token type"
        ) {
          notify(
            error.response?.data?.detail || "Something went wrong!",
            "info"
          );
        }
      } else if (error.response.status === 406) {
        notify(
          error.response?.data?.detail || "Something went wrong!",
          "info"
        );
      } else if (error.response.status === 403) {
        notify(
          error.response?.data?.detail || "Something went wrong!",
          "info"
        );
      }
    }
    return Promise.reject(error);
  }
);

export const CMS_BASE_URL = "https://cms.rosehealth.com";

export default axiosInstance;
